<template>
  <b-row>
    <b-col>
      <center>
        <span style="display-inline;">
          Calculated Data:
          <b-button size="sm" variant="link" @click="$emit('showModal', 'calculated')" class="px-0">
            <i class="fas fa-question-circle"></i>
          </b-button>
        </span>
      </center>
      <table class="table b-table internal-table" v-if="item.adj_override">
        <thead>
          <tr>
            <th>Calculation =</th>
            <th>Quantity Override</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>{{item.web_qty}}</strong></td>
            <td>{{item.adj_override}}</td>
          </tr>
        </tbody>
      </table>
      <table class="table b-table internal-table" v-else>
        <thead>
          <tr>
            <th>Calculation =</th>
            <th>Available For Sale</th>
            <th>+ Can Build In MOs</th>
            <th>+ Can Build/Make</th>
            <th>+ Web Inventory Adjustment</th>
            <th>- Qty in SO Estimates</th>
            <th>- Qty Needed to Build Parents</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>{{item.web_qty}}</strong> {{ item.qty_ceiling != 0 ? `(capped to ${item.qty_ceiling})` : "" }}</td>
            <td>{{item.fb_available_for_sale}}</td>
            <td>{{item.can_build_in_mos}}</td>
            <td>{{item.can_build_make}}</td>
            <td>{{item.adj_web_inventory}}</td>
            <td>{{item.in_so_estimates}}</td>
            <td>{{item.needed_in_parents}}</td>
          </tr>
        </tbody>
      </table>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: () => {} },
  },
}
</script>

<style scoped>
  *{text-align: center}
</style>



// WEBPACK FOOTER //
// src/components/inventory/CalculatedData.vue